import {Distance} from './Distance';
import {Duration} from './Duration';

export class Speed {
    public get durationPer500Meters(): Duration | null {
        if (this.metersPerSecond === 0) return null;

        return Duration.fromMinutes(((1 / this.metersPerSecond) * 500) / 60);
    }

    public static zero() {
        return new Speed(0);
    }

    private constructor(public metersPerSecond: number) {}

    public static fromDistanceAndDuration(distance: Distance, duration: Duration): Speed {
        if (duration.seconds === 0) {
            return new Speed(0);
        }
        return new Speed(distance.meters / duration.seconds);
    }

    public static fromDurationPer500Meters(duration: Duration | null): Speed | null {
        if (duration === null) {
            return null;
        }

        if (duration.seconds === 0) {
            return null;
        }
        return new Speed(500 / duration.seconds);
    }

    public static average(...speeds: Speed[]): Speed {
        if (speeds.length === 0) {
            return Speed.zero();
        }
        return speeds.reduce((p: Speed, c: Speed): Speed => p.add(c), Speed.zero()).div(speeds.length);
    }

    static fromMetersPerSecond(value: number) {
        return new Speed(value);
    }

    public add(other: Speed) {
        return new Speed(this.metersPerSecond + other.metersPerSecond);
    }

    public div(n: number): Speed {
        if (this.metersPerSecond === 0) {
            return new Speed(0);
        }
        return new Speed(this.metersPerSecond / n);
    }

    public lt(other: Speed): boolean {
        return this.metersPerSecond < other.metersPerSecond;
    }
}
